var map = {
	"./1376428_orig.jpg": 3928,
	"./1682681_orig.jpg": 4331,
	"./3454728_orig.jpg": 1411,
	"./3519828_orig.jpg": 4950,
	"./6849218_orig.jpg": 8798,
	"./8922022_orig.jpg": 7359
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5509;